import { configureStore } from './configureStore';

const user = JSON.parse(localStorage.getItem('user') || '{}');
const isLoggedIn = Object.keys(user).length > 0;

const preloadedState = isLoggedIn
  ? {
      session: {
        isLoggedIn: true,
        user: null,
        email: user.email || null,
        clasArDashboard: user.clasArDashboard || false,
      },
    }
  : {};

export default configureStore(preloadedState);
